<template>
  <div class="app-layout">
    <app-heading @home="showInitScreen" :subtitle="subtitle"/>

    <slot />

  </div>

</template>

<script>
import AppHeading from "./AppHeading"
import ContentCard from "../content/ContentCard"

export default {
  name: "AppLayout",
  components: {
    AppHeading,
    ContentCard,
  },
  props: {
    subtitle: {
      type: String,
      default: function () {
        return this.$t('headingSubtitle')
      },
    }
  },
  methods: {
    showInitScreen() {
      // this.$router.push('/')
      window.location = "/"
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/AppLayout.vue